import { render, staticRenderFns } from "./WaitingForAdditionalOwners.vue?vue&type=template&id=c4e54238&scoped=true&"
import script from "./WaitingForAdditionalOwners.vue?vue&type=script&lang=js&"
export * from "./WaitingForAdditionalOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e54238",
  null
  
)

export default component.exports